import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { partnerApi } from "../../../services/partnerApi";
import OnboardingStepFrame from "../../../components/instructor/OnboardingStepFrame";

const inputClass =
  "mt-1.5 w-full rounded-lg border border-emerald-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20";
const labelClass = "text-sm font-medium text-gray-900";
const sectionClass =
  "rounded-2xl border border-emerald-100/90 bg-white/90 p-5 shadow-sm sm:p-6 space-y-4";

export default function PartnerCommercialStep() {
  const { partner, refreshPartner } = useAuth();
  const navigate = useNavigate();
  const [cancellationPolicy, setCancellationPolicy] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!partner?.org) return;
    setCancellationPolicy(partner.org.cancellation_policy || "");
  }, [partner]);

  async function handleSave(e) {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      await partnerApi.patchOrg({
        cancellation_policy: cancellationPolicy,
      });
      await refreshPartner();
      navigate("/partner/onboarding/review");
    } catch (err) {
      setError(err.message || "Could not save");
    } finally {
      setSaving(false);
    }
  }

  return (
    <OnboardingStepFrame
      title="Cancellation policy"
      subtitle="Describe refund and cancellation terms guests should know before booking."
    >
      <form onSubmit={handleSave} className="space-y-5">
        {error && (
          <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>
        )}

        <div className={sectionClass}>
          <label className="block">
            <span className={labelClass}>Cancellation policy</span>
            <textarea
              required
              rows={5}
              className={inputClass}
              value={cancellationPolicy}
              onChange={(e) => setCancellationPolicy(e.target.value)}
              placeholder="Describe refund / cancellation terms guests should know…"
            />
          </label>
        </div>

        <div className="flex flex-wrap gap-3">
          <Link
            to="/partner/onboarding/media"
            className="rounded-lg border border-emerald-200 px-4 py-2.5 text-sm font-medium text-emerald-800 hover:bg-emerald-50"
          >
            Back
          </Link>
          <button
            type="submit"
            disabled={saving}
            className="rounded-lg bg-emerald-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-60"
          >
            {saving ? "Saving…" : "Save & continue"}
          </button>
        </div>
      </form>
    </OnboardingStepFrame>
  );
}
